import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-3',
  templateUrl: './cards-3.component.html'
})
export class Cards3Component {




    }
